import React from 'react';
import StaffWorkStandardsGeneric from './generics/StaffWorkStandardsGeneric';
import { checkOrganizingCampsInstructionFileAction, downloadOrganizingCampsInstructionDocumentAction } from '../../services/request';

export default function StaffOrganizingCampsInstructionDocuments ({ manager }) {
  return (
    <StaffWorkStandardsGeneric
      manager={manager}
      downloadDocumentAction={downloadOrganizingCampsInstructionDocumentAction}
      checkDocumentAction={checkOrganizingCampsInstructionFileAction}
      serializerFieldName="organizing_camps_instruction_documents"
      title="Instrukcje organizacji obozów"
      showChecked={false}
    />
  );
};
